import PartnerDirectory from "../components/PartnerDirectory";
import { Building2, Award, ShieldCheck, Handshake } from "lucide-react";

const FEATURES = [
    { icon: Building2, title: "RERA-Registered Projects", desc: "Every builder listing shows the MahaRERA / State-RERA registration number and possession dates." },
    { icon: Award, title: "Track-record Verified", desc: "5-year delivery history, past-project reviews and third-party audit reports available on request." },
    { icon: ShieldCheck, title: "Escrow-Backed Payments", desc: "70% of buyer payments go into a project-specific escrow account per RERA norms." },
    { icon: Handshake, title: "Direct Deals", desc: "No broker layer — connect with the developer's sales team and negotiate directly for the best price." },
];

export default function Builders() {
    return (
        <PartnerDirectory
            role="builder"
            roleLabel="Builders & Developers"
            roleLabelSingular="Builder"
            path="/builders"
            heroTag="Builders & Developers"
            heroTitle={<>Buy from builders you can <span className="text-gold-500">actually trust.</span></>}
            heroSubtitle="Verified RERA-registered developers with escrow-backed pricing, transparent possession timelines and proven track records across Nagpur, Mumbai and Pune."
            features={FEATURES}
            jsonLdCategory="RealEstateAgent"
        />
    );
}
